import { roleSchema } from '@billing/validation/role';
import { Permission } from 'interfaces';

export interface Role {
  id: string;
  name: string;
  organizationID: string;
  permissions?: Permission[];
}

export type FormRole = Omit<Role, 'id'>;

export const isRole = (obj: any): obj is Role => {
  return roleSchema.safeParse(obj).success;
};
